"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var context_1 = __importDefault(require("./context"));
var ReactDebuggerProvider = function (_a) {
    var children = _a.children;
    var _b = (0, react_1.useState)([]), debuggerProps = _b[0], setDebuggerProps = _b[1];
    var setDebuggerProp = function (prop) {
        var alreadyExists = debuggerProps.some(function (p) { return p.key === prop.key && p.value === prop.value; });
        if (!alreadyExists) {
            setDebuggerProps(function (oldProps) {
                var newProps = oldProps.filter(function (p) { return p.key !== prop.key; });
                return __spreadArray(__spreadArray([], newProps, true), [prop], false);
            });
        }
        return debuggerProps;
    };
    return (react_1.default.createElement(context_1.default.Provider, { value: {
            debuggerProps: debuggerProps,
            setDebuggerProp: setDebuggerProp,
        } }, children));
};
exports.default = ReactDebuggerProvider;
//# sourceMappingURL=store.js.map